var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 0l1.111 2 2.223.25L5.14 3.79 5.556 6 3.333 5 1.111 6l.419-2.21L0 2.25 2.222 2l1.111-2z",
    fill: "#456D45"
  })));
}
export default SvgFullStar;